import {translations} from 'presentation/translations-new';
import {z} from 'zod';

const {phones} = translations['pt-br'].privateFlow.profile.changeData.contactErrors;
export const CellPhoneSchema = z.object({
	cellphone: z
		.string()
		.min(15, phones)
		.transform(val => val.replace(/\D/g, ''))
		.refine(val => {
			const phone = val.slice(2);
			return phone.startsWith('9');
		}, phones),
});

export type CellPhoneFormValues = z.infer<typeof CellPhoneSchema>;
